// Register a minimal Apex grammar with react-syntax-highlighter's Prism.
// Prism doesn't ship Apex; we approximate with a Java-like grammar.
import {PrismLight as SyntaxHighlighter} from "react-syntax-highlighter";
import javascript from "react-syntax-highlighter/dist/esm/languages/prism/javascript";
import markup from "react-syntax-highlighter/dist/esm/languages/prism/markup";
import java from "react-syntax-highlighter/dist/esm/languages/prism/java";
import jsx from "react-syntax-highlighter/dist/esm/languages/prism/jsx";

SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("js", javascript);
SyntaxHighlighter.registerLanguage("jsx", jsx);
SyntaxHighlighter.registerLanguage("html", markup);
SyntaxHighlighter.registerLanguage("xml", markup);
SyntaxHighlighter.registerLanguage("markup", markup);
SyntaxHighlighter.registerLanguage("java", java);

// Apex is close enough to Java for highlighting purposes.
SyntaxHighlighter.registerLanguage("apex", java);

// LWC = JavaScript with HTML templates; default LWC blocks to JS.
SyntaxHighlighter.registerLanguage("lwc", javascript);

export default SyntaxHighlighter;
